import React, {useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {AXIOS} from "../../services/api";
import "./ResetPassword.scss";
import {Button} from "../../components/button/Button";
import {useAuth} from "../../hooks/useAuth";
import personalInfo from "../../assets/images/add-personal-info.png";

const useQuery = () => {
	return new URLSearchParams(useLocation().search);
};

const ResetPassword = () => {
	const query = useQuery();
	const token = query.get("token");

	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [passwordConfirmation, setPasswordConfirmation] = useState('');
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState("");

	const navigate = useNavigate();
	const {login} = useAuth();

	const handleSubmit = async (e) => {
		e.preventDefault();

		if (!email || !password || !passwordConfirmation) {
			setError("Please fill all fields");
			return;
		}

		if (password !== passwordConfirmation) {
			setError("Passwords do not match");
			return;
		}

		setIsLoading(true);
		setError("");

		try {
			const response = await AXIOS.post('/reset-password', {
				token,
				email,
				password,
				password_confirmation: passwordConfirmation,
			});

			if (response.status === 200) {
				await handleLogin();
			}
		} catch (error) {
			setError(error.response?.data?.error || "An error occurred. Please try again.");
		} finally {
			setIsLoading(false);
		}
	};

	async function handleLogin() {
		try {
			const response = await AXIOS.post("/login", {email, password});
			if (response.status === 200) {
				await login(response?.data?.data);
			}
		} catch (err) {
			setError("An error occurred during login");
		}
	}

	return (
		<div className="reset-password-page">
			<div className="container">
				<div className="reset-password-form">
					<div className="form-header">
						<h1>Reset Your Password</h1>
						<p>Create a new password for your account</p>
					</div>

					<form onSubmit={handleSubmit}>
						<div className="form-group">
							<label htmlFor="email">Email</label>
							<input
								type="email"
								id="email"
								value={email}
								onChange={(e) => setEmail(e.target.value)}
								placeholder="Enter your email"
								required
							/>
						</div>

						<div className="form-group">
							<label htmlFor="password">New Password</label>
							<input
								type="password"
								id="password"
								value={password}
								onChange={(e) => setPassword(e.target.value)}
								placeholder="Enter new password"
								required
							/>
						</div>

						<div className="form-group">
							<label htmlFor="passwordConfirmation">Confirm New Password</label>
							<input
								type="password"
								id="passwordConfirmation"
								value={passwordConfirmation}
								onChange={(e) => setPasswordConfirmation(e.target.value)}
								placeholder="Confirm new password"
								required
							/>
						</div>

						{error && <div className="error-message">{error}</div>}

						<div className="form-actions">
							<Button
								label={isLoading ? "Resetting Password..." : "Reset Password"}
								variant="primary"
								type="submit"
								disabled={isLoading}
							/>
						</div>
					</form>

					<div className="back-to-login">
						<Button
							label="Back to Sign In"
							variant="text"
							onClick={() => navigate("/login", {replace: true})}
						/>
					</div>
				</div>

				<div className="side-container">
					<div className="side-content">
						<img src={personalInfo} alt="App Review Management" />
						<h3>Secure Your Account</h3>
						<p>Create a strong password to keep your account secure and protect your app reviews.</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ResetPassword;
